import React, { CSSProperties, useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectActiveCompanyId } from '@mm/state/selectors/viewSelectors';
import strategyRedLogo from 'assets/whitelabel-logos/strategy-red.png';
import { WhitelabelContext } from '@mm/hooks';
import { IS_PROD_URL } from '@mm/utils';

export const WhitelabelProvider = ({ children }) => {
  const companyId = useSelector(selectActiveCompanyId);
  const companyIds = IS_PROD_URL ? [472201] : [819, 4591];
  const isWhitelabelCompany = companyIds.includes(companyId);
  const primaryColor = '#F42626';

  const getWhitelableLogo = (src: string, width?: number) => (
    <img src={src} style={{ width }} />
  );

  const getCompanyConfig = useCallback(() => {
    const commonTextStyle: CSSProperties = {
      fontSize: '14px',
      fontWeight: 500,
      lineHeight: '22px',
    };
    switch (true) {
      case companyIds.includes(companyId):
        return {
          companyName: 'Strategy RED',
          pixelName: 'RED Eye',
          companyLogo: getWhitelableLogo(strategyRedLogo, 120),
          primaryColor,
          primaryButtonStyle: {
            background: '#F42626',
            border: `1px solid ${primaryColor}`,
            color: 'white',
            ...commonTextStyle,
          },
          secondaryButtonStyle: {
            border: `1px solid ${primaryColor}`,
            color: primaryColor,
          },
          isWhitelabelCompany,
          supportEmail: 'zach@strategyredsports.com',
        };
      default:
        return {};
    }
  }, [isWhitelabelCompany, companyIds]);

  const config = useMemo(
    () => getCompanyConfig(),

    [getCompanyConfig],
  );

  return (
    <WhitelabelContext.Provider value={config}>
      {children}
    </WhitelabelContext.Provider>
  );
};
